import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";
import testimonial1 from "../assets/testimonial1.png";
import testimonial2 from "../assets/testimonial2.jpg";
import testimonial3 from "../assets/testimonial3.jpg";
import testimonial4 from "../assets/testimonial4.jpg";
import testimonial5 from "../assets/testimonial5.jpg";
import logo from "../assets/logo.png";

export const TestimonialSwiper = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  
   const userImages = {
    testimonial1: testimonial1,
    testimonial2: testimonial2,
    testimonial3: testimonial3,
    testimonial4: testimonial4,
    testimonial5: testimonial5,
  };


  // Testimonial data
  const testimonials = [
    {
      id: 1,
      name: "Sarah Magonic",
      title: "Chief Operating Officer, 18K+ Followers",
      userImg: "testimonial1",
      image: "testimonial1",
      rating: 5,
      text: "Operationally, the ROI was immediate. We reduced our photoshoot budgets by up to 80% by eliminating the need for models, studios, and travel overhead. It's a scalable solution that has removed the logistical complexity from our imagery production.",
      bgColor: "bg-white",
    },
    {
      id: 2,
      name: "Alex Chen",
      title: "E-Commerce Director, 7.5K+ Followers",
      userImg: "testimonial2",
      image: "testimonial2",
      rating: 5,
      text: "Gomens has fundamentally changed our speed to market. We've eliminated the slow execution of traditional shoots, converting garment images to a full product catalog in minutes. Our catalog imagery is now incredibly consistent across all channels, and the budget we've saved is significant.",
      bgColor: "bg-white",
    },
    {
      id: 3,
      name: "David Park",
      title: "Brand and Sustainability Manager, 9K+ Followers",
      userImg: "testimonial3",
      image: "testimonial3",
      rating: 4,
      text: "Sustainability is woven into our GTM process, and Gomens is a key partner in that mission. By validating our designs virtually, we significantly minimize waste from physical samples and overproduction.",
      bgColor: "bg-white",
    },
    {
      id: 4,
      name: "Maya Rodriguez",
      title: "Founder and Creative Director, 12K+ Followers",
      userImg: "testimonial4",
      image: "testimonial4",
      rating: 5,
      text: "As an emerging designer, the high costs of traditional photoshoots were a huge barrier. Gomens provides me the creative freedom, allowing me to showcase designs on diverse models and bring my vision to life without a massive budget.",
      bgColor: "bg-white",
    },
    {
      id: 5,
      name: "Max Thompson",
      title: "Head of Digital Marketing, 25K+ Followers",
      userImg: "testimonial5",
      image: "testimonial5",
      rating: 4,
      text: "To connect with our consumers, we need diverse and inclusive imagery, which used to be resource-intensive to produce. Gomens enables us to generate thousands of tailored visuals instantly, allowing us to connect more deeply with consumers through diverse representation",
      bgColor: "bg-white",
    },
  ];

  // Auto-play functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goToPrev = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const getCardStyle = (index) => {
    const diff = index - currentIndex;
    const totalCards = testimonials.length;

    // Normalize the difference to handle circular array
    let normalizedDiff = diff;
    if (diff > totalCards / 2) normalizedDiff = diff - totalCards;
    if (diff < -totalCards / 2) normalizedDiff = diff + totalCards;

    if (normalizedDiff === 0) {
      // Current card
      return {
        transform: "translateX(0%) scale(1)",
        opacity: 1,
        filter: "blur(0px)",
        zIndex: 10,
      };
    } else if (normalizedDiff === 1) {
      // Next card (right)
      return {
        transform: "translateX(70%) scale(0.85)",
        opacity: 0.6,
        filter: "blur(2px)",
        zIndex: 5,
      };
    } else if (normalizedDiff === -1) {
      // Previous card (left)
      return {
        transform: "translateX(-70%) scale(0.85)",
        opacity: 0.6,
        filter: "blur(2px)",
        zIndex: 5,
      };
    } else {
      // Hidden cards
      return {
        transform: `translateX(${
          normalizedDiff > 0 ? "100%" : "-100%"
        }) scale(0.7)`,
        opacity: 0,
        filter: "blur(4px)",
        zIndex: 1,
      };
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F4F3] py-6 sm:py-8 md:py-12 mt-8 sm:mt-12 md:mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-16 md:mb-16">
          <div className="bg-transparent text-clip rounded-full text-sm sm:text-base md:text-lg font-medium mb-4">
            Creator Approved
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 leading-tight">
            Loved by Designers, Creators,
            <br className="hidden sm:block" />
            <span className="sm:hidden"> </span>and Shops
          </h1>
          <p className="text-sm sm:text-base md:text-lg max-w-2xl mx-auto px-4">
            See how real users are leveling up their visuals and workflows with Gomens
          </p>
        </div>

        {/* Slider Container */}
        <div
          className="relative flex items-center justify-center overflow-hidden"
          style={{ height: 'clamp(300px, 60vh, 500px)' }}
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          {/* Navigation Buttons - Hidden on mobile */}
          <button
            onClick={goToPrev}
            className="hidden sm:flex absolute left-2 md:left-4 z-20 w-10 h-10 md:w-12 md:h-12 bg-white rounded-full items-center justify-center hover:bg-gray-50 transition-colors shadow-lg"
          >
            <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
          </button>

          <button
            onClick={goToNext}
            className="hidden sm:flex absolute right-2 md:right-4 z-20 w-10 h-10 md:w-12 md:h-12 bg-white rounded-full items-center justify-center hover:bg-gray-50 transition-colors shadow-lg"
          >
            <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
          </button>

          {/* Cards */}
          <div className="relative w-full flex items-center justify-center mb-0" 
               style={{ height: 'clamp(280px, 55vh, 420px)' }}>
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className="absolute transition-all duration-700 ease-in-out cursor-pointer w-full max-w-xs sm:max-w-sm md:max-w-2xl lg:max-w-4xl xl:max-w-5xl"
                style={{
                  ...getCardStyle(index),
                  height: 'clamp(280px, 55vh, 420px)',
                }}
                onClick={() => setCurrentIndex(index)}
              >
                <div className={`w-full h-full rounded-xl ${testimonial.bgColor} overflow-hidden shadow-xl`}>
                  {/* Mobile Layout - Stacked */}
                  <div className="flex flex-col md:flex-row h-full">
                    {/* Image Section */}
                    {testimonial.userImg && (
                      <div className="w-full md:w-2/5  h-32 sm:h-40 md:h-full flex-shrink-0">
                        <img
                          src={userImages[testimonial.userImg]}
                          alt=""
                          className="md:w-[410px] md:h-[420px] h-[210px] object-cover w-[400px] object-top md:object-cover"
                        />
                      </div>
                    )}
                    
                    {/* Content Section */}
                    <div className="flex-1 p-4 sm:p-6 md:p-8 lg:p-10 xl:p-12 flex flex-col justify-between">
                      {/* Header with Rating and Logo */}
                      <div className="flex justify-between items-start md:mb-6">
                        <div className="flex space-x-1 mt-20 md:mt-5" >
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <Star
                              key={i}
                              className="w-3 h-3 sm:w-4 sm:h-4 fill-yellow-400 text-yellow-400"
                            />
                          ))}
                        </div>
                        <img
                          src={logo}
                          alt="logo"
                          className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 lg:w-16 lg:h-16 mt-18 md:mt-0"
                        />
                      </div>

                      {/* Testimonial Text */}
                      <div className="flex-1 flex items-center">
                        <p className="text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl leading-relaxed">
                          {testimonial.text}
                        </p>
                      </div>

                      {/* User Info */}
                      <div className="flex items-center space-x-3 mt-4 sm:mt-6 sm:mb-0">
                        <img
                          src={userImages[testimonial.image]}
                          alt={testimonial.name}
                          className="w-8 h-8 sm:w-10 sm:h-10 object-fill rounded-full border-2 border-white/30"
                        />
                        <div>
                          <h3 className="text-black font-semibold text-xs sm:text-sm md:text-base">
                            {testimonial.name}
                          </h3>
                          <p className="text-black text-xs sm:text-xs md:text-sm opacity-75">
                            {testimonial.title}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Swipe Navigation */}
        <div className="flex justify-center space-x-4 sm:hidden mb-0">
          <button
            onClick={goToPrev}
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors shadow-lg"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={goToNext}
            className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors shadow-lg"
          >
            <ChevronRight className="w-5 h-5 sm:mb-0" />
          </button>
        </div>
      </div>
    </div>
  );
};